<h1>Cancel subscription</h1>
<form (ngSubmit)="submit(form)" #form="ngForm">
  <div class="row cancel-subscription">
    <div class="col-sm-12 col-md-12 col-12">
      <div class="card mb-9">
        <div class="card-header">Cancel subscription info</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="form-group">
                <label for="member-edit-email">Email to send report</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="subscriptionData.email"
                  name="email"
                  #email="ngModel"
                  class="form-control"
                  id="member-edit-email"
                  required
                  [readonly]="formLocked"
                />
                <small
                  class="text-danger"
                  *ngIf="(email.touched || email.dirty) && !email.valid"
                >
                  Email is invalid.
                </small>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="form-group">
                <label for="subscription-start-date-picker">Start Date</label>
                <ch-datepicker
                  (onChange)="startDateChange($event)"
                  [date]="subscriptionData.startDate"
                  id="subscription-start-date-picker"
                ></ch-datepicker>

                <small
                  class="text-danger"
                  *ngIf="!subscriptionData.startDate && submited"
                >
                  Start Date is required.
                </small>
                <small
                  class="text-danger"
                  *ngIf="isStartDateIsBigger()"
                >
                  End date must be after start date.
                </small>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="form-group">
                <label for="subscription-start-date-picker">End Date</label>
                <ch-datepicker
                  (onChange)="endDateChange($event)"
                  [date]="subscriptionData.endDate"
                  id="subscription-start-date-picker"
                ></ch-datepicker>

                <small
                  class="text-danger"
                  *ngIf="!subscriptionData.endDate && submited"
                >
                  End Date is required.
                </small>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button
            id='cancelSubscriptionSubmit' type="submit" class="btn btn-primary" [disabled]="formLocked">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/cancel-subscription/cancel-subscription.component.html